import { Component, ElementRef } from '@angular/core';

import { IS_PANEL_SIDEBAR_HIDDEN, IS_PANEL_SIDEBAR_SHOWN } from 'Angular/constants/list-page.constants';
import { FilterSidebarShownClass } from 'Angular/types/is-panel-sidebar-shown-css-class.type';

import { AccountsService } from 'AccountsApp/ts/services/accounts.service';
import { SearchAllStateService } from 'SearchApp/ts/apps/search-all-app/services/search-all-state.service';

/**
 *
 * SearchAllPageComponent.
 *
 * This component is the page that holds the components for the search result lists, search bar and
 * filters by category.
 */
@Component({ standalone: false, selector: 'ycn-search-all-page', templateUrl: './search-all-page.template.html' })
export class SearchAllPageComponent {
    filterSidebarShownClass: FilterSidebarShownClass = IS_PANEL_SIDEBAR_SHOWN;

    IS_PANEL_SIDEBAR_HIDDEN = IS_PANEL_SIDEBAR_HIDDEN;

    constructor(
        private accountsService: AccountsService,
        private eltRef: ElementRef,
        private searchAllAppState: SearchAllStateService
    ) {
        this.searchAllAppState.initAppState();
        const initialFilterSidebarShown = eltRef.nativeElement.getAttribute('filterSidebarShown') === 'True';
        this.filterSidebarShownClass = initialFilterSidebarShown ? IS_PANEL_SIDEBAR_SHOWN : IS_PANEL_SIDEBAR_HIDDEN;
    }

    toggleFilterSidebar(isOpen: boolean): void {
        this.filterSidebarShownClass = isOpen ? IS_PANEL_SIDEBAR_SHOWN : IS_PANEL_SIDEBAR_HIDDEN;
        const params = { search_list_show_filter_sidebar: isOpen ? 'True' : 'False' };
        this.accountsService.putUserPreferences(params).subscribe();
    }
}
